<template>
  <Menu></Menu>
  <div id="box">
    <!-- =========================================================================================================== -->
    <div class="container mb-2">
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0 text-center">
          <h5 class="fw-bold d-inline-block bi-columns-gap">&nbsp; Manage Tires</h5>
        </div>
        <div class="col-auto text-center">
          <button class="btn btn-dark w-100 bi-arrow-clockwise" @click="loadTires()" :disabled="isBusy || loading">&nbsp; Reload</button>
        </div>
        <div class="col-auto p-0">
          <button class="btn w-100 btn-success bi-file-earmark-excel-fill" @click="xlsx()" :disabled="isBusy || loading">&nbsp; Excel</button>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0">
          <hr>
        </div>
      </div>
      <!-- ----------------------------------------------- -->          
      <div class="row p-0">

        <div class="col p-0">
          <div class="input-group w-100">
            <span class="input-group-text bi-search"></span>
            <input class="form-control" type="text" placeholder="Search by name" v-model.trim='filter'>
          </div>
        </div>
        
        <div class="col p-0">
        </div>
        
        <div class="col">
        </div>

        <div class="col  p-0">
          <button v-if="$store.getters.access('tire_add')" class="btn btn-success w-100" @click="showAddTire()" :disabled="isBusy || loading">
            <span class="bi-plus-circle">&nbsp; Add Tire</span>
          </button>
        </div>

      </div>
    </div>
    <!-- =========================================================================================================== -->
    <table class="table table-sm table-bordered table-striped table-hover table-fixed">
      <!-- ----------------------------------------------- -->
      <thead>
        <tr class="table-dark">
          <th class="w-15">Brand</th>
          <th class="w-15">Size</th>
          <th class="w-15">Pattern</th>
          <th class="">barcode</th>
          <th v-if="$store.getters.access('cost')" class="w-10 text-center">Cost</th>
          <th v-if="$store.getters.access('price')" class="w-10 text-center">Price</th>
          <th v-if="tax > 0 && $store.getters.access('price')" class="w-10 text-center">Price after <br> {{tax}}% Tax</th>
          <th v-if="$store.getters.access('price')" class="w-10 text-center">Premium <br> WS Price</th>
          <th v-if="ws_rate > 0 && $store.getters.access('price')" class="w-10 text-center">Regular WS Price {{ws_rate}}%</th>
          <th v-if="$store.getters.access(['tire_edit', 'tire_del'])"  class="text-center w-50px"><span class="bi-gear"></span></th>
        </tr>
      </thead>
      <!-- ----------------------------------------------- -->
      <tbody style="height: calc(100vh - 190px)">
        <LoadingRow v-if="isBusy"></LoadingRow>
        
        <tr v-for="tire in tires_filtered" :key="tire._id">
          <td class="w-15">{{ tire.brandName }}</td>
          <td class="w-15">{{ tire.sizeName }}</td>
          <td class="w-15">{{ tire.patternName }}</td>
          <td class="">{{ tire.barcode }}</td>
          <td v-if="$store.getters.access('cost')" class="w-10 text-center">{{ tire.cost }}</td>
          <td v-if="$store.getters.access('price')" class="w-10 text-center">{{ tire.price }}</td>
          <td v-if="tax > 0 && $store.getters.access('price')" class="w-10 text-center">
            <p>{{ (tire.price * (100 + tax) / 100).toFixed(2) }}</p>
          </td>
          <td v-if="$store.getters.access('price')" class="w-10 text-center">
            <p>{{ tire.ws_price }}</p>
          </td>
          <td v-if="ws_rate > 0 && $store.getters.access('price')" class="w-10 text-center">
            <p>{{ ((tire.ws_price || 0) * (100 + ws_rate) / 100).toFixed(2) }}</p>
          </td>

          <td v-if="$store.getters.access(['tire_edit', 'tire_del'])" class="dropstart text-center w-50px">
            <a data-bs-toggle='dropdown' class="btn btn-sm btn-secondary p-1"><span class="bi-three-dots-vertical"></span></a>
            <ul class="dropdown-menu">
              <li v-if="$store.getters.access('tire_edit')"><a class="dropdown-item bi-pencil-fill" @click="showEditTire(tire)">Edit</a></li>
              <li v-if="$store.getters.access('tire_del')"><a class="dropdown-item bi-trash text-danger" @click="delTire(tire)">Delete</a></li>
            </ul>
          </td>
        </tr>
      </tbody>
      <!-- ----------------------------------------------- -->
    </table>
    <!-- =========================================================================================================== -->
    <div id="addTireModal" ref="addTireModal" class="modal fade">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Add New Tire</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body text-center">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Brand</span>
              <Select2 v-model="newTire.brand" :options="brands" :settings="brands_select2_settings"/>
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Size</span>
              <Select2 v-model="newTire.size" :options="sizes" :settings="sizes_select2_settings"/>
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Pattern</span>
              <Select2 v-model="newTire.pattern" :options="patterns" :settings="patterns_select2_settings"/>
            </div>
            <div v-if="$store.getters.access('cost_edit')" class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Cost</span>
              <input class="form-control" type="number" v-model.trim="newTire.cost">
            </div>
            <div v-if="$store.getters.access('price_edit')" class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Price</span>
              <input class="form-control" type="number" v-model.trim="newTire.price">
            </div>
            <div v-if="tax > 0 && $store.getters.access('price_edit')" class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Price after <br> {{tax}}% Tax</span>
              <input class="form-control" type="number" disabled :value="(newTire.price * (100 + tax) / 100).toFixed(2)">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Barcode</span>
              <input class="form-control" type="text" v-model.trim="newTire.barcode" @input="barcodeChangedNew()" @change="barcodeChangedNew()">
            </div>
            <svg v-bind:class="newTire.barcode ? '' : 'd-none'" class="barcode" ref="newBarcode"></svg>
            <!-- <vue3-barcode v-bind:value="newTire.barcode" :height="50" /> -->
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <a class="btn btn-success w-100" @click="addTire()">
                    <span v-if="loading" class="spinner-border"></span>
                    <span>Add</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <div id="editTireModal" ref="editTireModal" class="modal fade">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Edit Tire: {{ editTire.nameOriginal }}</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body text-center">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Brand</span>
              <Select2 v-model="editTire.brand" :options="brands" :settings="brands_select2_settings"/>
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Size</span>
              <Select2 v-model="editTire.size" :options="sizes" :settings="sizes_select2_settings"/>
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Pattern</span>
              <Select2 v-model="editTire.pattern" :options="patterns" :settings="patterns_select2_settings"/>
            </div>
            <div v-if="$store.getters.access('cost_edit')" class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Cost</span>
              <input class="form-control" type="number" v-model.trim="editTire.cost">
            </div>
            <div v-if="$store.getters.access('price_edit')" class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Price</span>
              <input class="form-control" type="number" v-model.trim="editTire.price">
            </div>
            <div v-if="tax > 0 && $store.getters.access('price_edit')" class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Price after <br> {{tax}}% Tax</span>
              <input class="form-control" type="number" disabled :value="(editTire.price * (100 + tax) / 100).toFixed(2)">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Barcode</span>
              <input class="form-control" type="text" v-model.trim="editTire.barcode" @input="barcodeChangedEdit()" @change="barcodeChangedEdit()">
            </div>
            <svg v-bind:class="editTire.barcode ? '' : 'd-none'" class="barcode" ref="editBarcode"></svg>
            <!-- <vue3-barcode v-bind:value="editTire.barcode" :height="50" /> -->
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <a class="btn btn-success w-100" @click="saveTire()">
                    <span v-if="loading" class="spinner-border"></span>
                    <span>Save</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
  </div>

</template>
<!-- ******************************************************** -->
<script>
  const $ = require('jquery');
  var JsBarcode = require("jsbarcode");
  export default {
    name: 'TiresPage',
    data(){
      return {
        loading: false,
        tires: [],
        isBusy: false,
        filter: '',
        brands: [],
        sizes: [],
        patterns: [],
        tax: 0,
        ws_rate: 0,

        newTire:{
          name: '',
          brand: '',
          size: '',
          pattern: '',
          barcode: '',
          cost: 0,
          price: 0,
        },
        editTire:{
          id: '',
          nameOriginal: '',
          brand: '',
          size: '',
          pattern: '',
          barcode: '',
          cost: 0,
          price: 0,
        },
        brands_select2_settings:{
          theme: "bootstrap-5",
          placeholder: 'Search for Brands',
          width: '350px',
        },
        sizes_select2_settings:{
          theme: "bootstrap-5",
          placeholder: 'Search for Sizes',
          width: '350px',
        },
        patterns_select2_settings:{
          theme: "bootstrap-5",
          placeholder: 'Search for Patterns',
          width: '350px',
        },
      }
    },
    async created() {
      if(this.$store.getters.access(['tire_add', 'tire_edit'])){
        await this.loadSpecs();
      }
      await this.loadTires();
      var code = "", reading = false;
      document.addEventListener('keypress', (e) => {
        if (e.keyCode === 13) {
            if(code.length >= 8) {
              this.onBarcodeScan(code);
              code = "";
            }
        }
        else { code += e.key; }
        if(!reading) {
            reading = true;
            setTimeout(() => { code = ""; reading = false;}, 200);
        }
      });
    },
    //**********************************************************
    computed:{
      tires_filtered(){
        let filter = this.filter.toLowerCase();
        return this.tires.filter((x)=>{
          if(x.barcode && x.barcode.toLowerCase().includes(filter)) return true;
          if(x.brandName && x.brandName.toLowerCase().includes(filter)) return true;
          if(x.sizeName && x.sizeName.toLowerCase().includes(filter)) return true;
          if(x.patternName && x.patternName.toLowerCase().includes(filter)) return true;
          if(x._id && x._id.toLowerCase().includes(filter)) return true;
          return false;
        });
      }
    },
    //**********************************************************
    methods:{
      //**********************************************************
      async loadSpecs(){
        this.isBusy = true;
        this.brands = this.sizes = this.patterns = [];
        var ack = await this.$service.getSpecs();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.brands = ack.data.brands;
          this.sizes = ack.data.sizes;
          this.patterns = ack.data.patterns;
        }
        this.isBusy = false;
      },
      //**********************************************************
      async loadTires(){
        this.isBusy = true;
        this.tires = [];
        var ack = await this.$service.getTires();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.tires = ack.data.tires;
          this.tax = ack.data.tax;
          this.ws_rate = ack.data.ws_rate;
        }
        this.isBusy = false;
      },
      //**********************************************************
      async xlsx(){
        this.loading = true;
        
        var ack = await this.$service.getTires({ xlsx: true }, 'blob');
        if(!ack){
          this.$toast('Error');
        }
        else{
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(ack.blob);
          link.download = ack.fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        
        this.loading = false;
      },
      //**********************************************************
      async onBarcodeScan(code){
        if($('#addTireModal').hasClass('show')){
          this.newTire.barcode = code;
          this.barcodeChangedNew();
        }
        else if($('#editTireModal').hasClass('show')){
          this.editTire.barcode = code;
          this.barcodeChangedEdit();
        }
        else this.filter = code;
      },
      //**********************************************************
      async showAddTire(){
        $('#addTireModal').modal('show');
      },
      //**********************************************************
      async addTire(){
        this.loading = true;
        await this._addTire();
        this.loading = false;
      },
      //**********************************************************
      async _addTire(){
        // console.log(this.newTire);
        if(!this.newTire.brand || !this.newTire.size || !this.newTire.pattern || !this.newTire.barcode){
          return this.$toast('Some Fields are empty', 'warning');
        }
        var ack = await this.$service.addTire({
          brand: this.newTire.brand,
          size: this.newTire.size,
          pattern: this.newTire.pattern,
          barcode: this.newTire.barcode,
          cost: this.newTire.cost,
          price: this.newTire.price,
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        $('#addTireModal').modal('hide');
        this.$toast('Tire Added Successfuly', 'success');
        this.loadTires();
      },
      //**********************************************************
      async showEditTire(tire){
        this.editTire.id = tire._id;
        this.editTire.nameOriginal = `${tire.brandName} - ${tire.sizeName} - ${tire.patternName}`;
        this.editTire.brand = tire.brand;
        this.editTire.size = tire.size;
        this.editTire.pattern = tire.pattern;
        this.editTire.barcode = tire.barcode;
        this.editTire.price = tire.price;
        this.editTire.cost = tire.cost;
        this.barcodeChangedEdit();
        $('#editTireModal').modal('show');
      },
      //**********************************************************
      async saveTire(){
        this.loading = true;
        await this._saveTire();
        this.loading = false;
      },
      //**********************************************************
      async _saveTire(){
        if(!this.editTire.brand || !this.editTire.size || !this.editTire.pattern){
          return this.$toast('Some Fields are empty', 'warning');
        }
        var ack = await this.$service.editTire({
          id: this.editTire.id,
          brand: this.editTire.brand,
          size: this.editTire.size,
          pattern: this.editTire.pattern,
          barcode: this.editTire.barcode,
          cost: this.editTire.cost,
          price: this.editTire.price,
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        $('#editTireModal').modal('hide');
        this.$toast('Tire Saved Successfuly', 'success');
        this.loadTires();
      },
      //**********************************************************
      async delTire(tire){
        var reply = await this.$swal.fire({
          title: "Confirm Delete",
          html: `Are you sure you want to delete the tire <b>(${tire.brandName}, ${tire.sizeName}, ${tire.patternName})</b>`,
          icon: "error", showCancelButton: true, focusCancel: true,
          confirmButtonText: "Confirm Delete", confirmButtonColor: "#d33", 
        });
        if(!reply.isConfirmed) return;
        this.loading = true;
        var ack = await this.$service.delTire({ id: tire._id });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.$toast('Tire Deleted Successfuly', 'success');
          this.loadTires();
        }
        this.loading = false;
      },
      //**********************************************************
      //**********************************************************
      //**********************************************************
      //**********************************************************
      //**********************************************************
      barcodeChangedNew(){
        if(!this.newTire.barcode) return;
        JsBarcode(this.$refs.newBarcode, this.newTire.barcode)
      },
      barcodeChangedEdit(){
        if(!this.editTire.barcode) return;
        JsBarcode(this.$refs.editBarcode, this.editTire.barcode)
      }
      //**********************************************************
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
</style>
  